module.exports = __webpack_public_path__ + "static/media/visinema group_black.0b14f8c0.png";